import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Package, Zap, Images, Tags, ClipboardList, LogOut, Menu, X, Boxes, DatabaseBackup, Barcode, ScanLine, Brain, TrendingUp, Scale } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/customers", label: "Müşteriler", icon: Users, testid: "admin-nav-customers" },
  { to: "/admin/products", label: "Ürünler", icon: Package, testid: "admin-nav-products" },
  { to: "/admin/group-6007", label: "6007 Ürünleri", icon: Boxes, testid: "admin-nav-group-6007" },
  { to: "/admin/quick-add", label: "Hızlı Ekle", icon: Zap, testid: "admin-nav-quick" },
  { to: "/admin/bulk-photos", label: "Toplu Fotoğraf", icon: Images, testid: "admin-nav-bulk-photos" },
  { to: "/admin/categories", label: "Kategoriler", icon: Tags, testid: "admin-nav-categories" },
  { to: "/admin/concepts", label: "AI Kavramlar", icon: Brain, testid: "admin-nav-concepts" },
  { to: "/admin/search-analytics", label: "Arama Analitiği", icon: TrendingUp, testid: "admin-nav-search-analytics" },
  { to: "/admin/tray-barcodes", label: "Tabla Barkodları", icon: Barcode, testid: "admin-nav-tray-barcodes" },
  { to: "/admin/tray-scan", label: "Tabla Tara", icon: ScanLine, testid: "admin-nav-tray-scan" },
  { to: "/admin/orders", label: "Siparişler", icon: ClipboardList, testid: "admin-nav-orders" },
  { to: "/admin/bulk-gram", label: "Toplu Gram", icon: Scale, testid: "admin-nav-bulk-gram" },
  { to: "/admin/backup", label: "Yedekleme", icon: DatabaseBackup, testid: "admin-nav-backup" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  const SidebarContent = () => (
    <>
      <div className="px-6 py-5 border-b border-border">
        <img src="/orse-logo.png" alt="ORSE GOLD" className="h-10 w-auto object-contain" />
        <div className="text-[10px] tracking-luxe uppercase text-muted-foreground mt-2">Yönetim Paneli</div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {links.map((l) => {
          const Icon = l.icon;
          return (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive ? "bg-gold/15 text-gold border border-gold/30" : "text-muted-foreground hover:text-foreground hover:bg-elevated border border-transparent"
                }`
              }
            >
              <Icon size={18} strokeWidth={1.5} />
              {l.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="px-3 py-4 border-t border-border">
        <div className="px-3 mb-3 text-xs text-muted-foreground truncate">{user?.email}</div>
        <button
          data-testid="admin-logout-button"
          onClick={doLogout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-md text-sm text-muted-foreground hover:text-red-400 hover:bg-elevated transition-colors"
        >
          <LogOut size={18} strokeWidth={1.5} /> Çıkış Yap
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-obsidian text-foreground flex">
      <aside className="hidden md:flex flex-col w-64 border-r border-border bg-surface fixed inset-y-0 left-0">
        <SidebarContent />
      </aside>

      {open && (
        <div className="md:hidden fixed inset-0 z-50 flex">
          <div className="w-64 flex flex-col bg-surface border-r border-border">
            <SidebarContent />
          </div>
          <div className="flex-1 bg-black/60" onClick={() => setOpen(false)} />
        </div>
      )}

      <div className="flex-1 md:ml-64 min-w-0">
        <header className="md:hidden sticky top-0 z-40 backdrop-blur-xl bg-black/85 border-b border-border flex items-center justify-between px-5 h-16">
          <img src="/orse-logo.png" alt="ORSE GOLD" className="h-8 w-auto object-contain" />
          <button data-testid="admin-menu-toggle" onClick={() => setOpen(!open)} className="p-2 border border-border rounded-md">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </header>
        <main className="p-5 md:p-8 max-w-6xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
